import React from 'react';
import propTypes from 'prop-types';
import ViewCompareMultiTypeAnalytics from './ViewCompareMultiTypeAnalytics';
import ViewComparePontiacAnalytics from './ViewComparePontiacAnalytics';
import ViewCompareGoogleAnalytics from './ViewCompareGoogleAnalytics';

const ViewCompareAnalytics = ({
    campaignType,
    campaign1Id,
    campaign2Id,
    campaign3Id,
    campaign4Id,
    campaign5Id,
    campaign1TypeId,
    campaign2TypeId,
    campaign3TypeId,
    campaign4TypeId,
    campaign5TypeId,
}) => {
    switch (campaignType) {
        case 'Multi':
            return (
                <ViewCompareMultiTypeAnalytics
                    campaignType={campaignType}
                    campaign1Id={campaign1Id}
                    campaign2Id={campaign2Id}
                    campaign3Id={campaign3Id}
                    campaign4Id={campaign4Id}
                    campaign5Id={campaign5Id}
                    campaign1TypeId={campaign1TypeId}
                    campaign2TypeId={campaign2TypeId}
                    campaign3TypeId={campaign3TypeId}
                    campaign4TypeId={campaign4TypeId}
                    campaign5TypeId={campaign5TypeId}
                />
            );
        case 'Google':
            return (
                <ViewCompareGoogleAnalytics
                    campaignType={campaignType}
                    campaign1Id={campaign1Id}
                    campaign2Id={campaign2Id}
                    campaign3Id={campaign3Id}
                    campaign4Id={campaign4Id}
                    campaign5Id={campaign5Id}
                    campaign1TypeId={campaign1TypeId}
                    campaign2TypeId={campaign2TypeId}
                    campaign3TypeId={campaign3TypeId}
                    campaign4TypeId={campaign4TypeId}
                    campaign5TypeId={campaign5TypeId}
                />
            );
        case 'Programmatic':
            return (
                <ViewComparePontiacAnalytics
                    campaignType={campaignType}
                    campaign1Id={campaign1Id}
                    campaign2Id={campaign2Id}
                    campaign3Id={campaign3Id}
                    campaign4Id={campaign4Id}
                    campaign5Id={campaign5Id}
                    campaign1TypeId={campaign1TypeId}
                    campaign2TypeId={campaign2TypeId}
                    campaign3TypeId={campaign3TypeId}
                    campaign4TypeId={campaign4TypeId}
                    campaign5TypeId={campaign5TypeId}
                />
            );
        default:
            return (
                <ViewCompareMultiTypeAnalytics
                    campaignType={campaignType}
                    campaign1Id={campaign1Id}
                    campaign2Id={campaign2Id}
                    campaign3Id={campaign3Id}
                    campaign4Id={campaign4Id}
                    campaign5Id={campaign5Id}
                    campaign1TypeId={campaign1TypeId}
                    campaign2TypeId={campaign2TypeId}
                    campaign3TypeId={campaign3TypeId}
                    campaign4TypeId={campaign4TypeId}
                    campaign5TypeId={campaign5TypeId}
                />
            );
    }
};

ViewCompareAnalytics.propTypes = {
    campaignType: propTypes.string,
    campaign1Id: propTypes.string,
    campaign2Id: propTypes.string,
    campaign3Id: propTypes.string,
    campaign4Id: propTypes.string,
    campaign5Id: propTypes.string,
    campaign1TypeId: propTypes.string,
    campaign2TypeId: propTypes.string,
    campaign3TypeId: propTypes.string,
    campaign4TypeId: propTypes.string,
    campaign5TypeId: propTypes.string,
};

export default ViewCompareAnalytics;
